var Entity = /** @class */ (function () {
    function Entity() {
        var _this = this;
        this._id = 0;
        // TODO: make array
        this.components = new Map();
        this._destroyed = true;
        // TODO: hide these behind Symbols?
        this.__set = function (entityId, components) {
            _this._id = entityId;
            _this.components.clear();
            components.forEach(function (comp) {
                _this.components.set(comp.__type, comp);
            });
            _this._destroyed = false;
        };
        this.__addComponent = function (instance) {
            _this.components.set(instance.__type, instance);
        };
        this.__removeComponent = function (typeId) {
            var instance = _this.components.get(typeId);
            _this.components.delete(typeId);
            return instance;
        };
        this.get = function (Type) {
            var _a;
            var instance = ((_a = _this.components.get(Type.id)) !== null && _a !== void 0 ? _a : null);
            console.assert(!instance || instance.id !== 0, "Entity tried to access recycled Component instance of type " + Type.name);
            return instance;
        };
        this.maybeGet = function (Type) {
            var _a;
            return ((_a = _this.components.get(Type.id)) !== null && _a !== void 0 ? _a : null);
        };
    }
    Object.defineProperty(Entity.prototype, "id", {
        get: function () {
            return this._id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Entity.prototype, "destroyed", {
        get: function () {
            return this._destroyed;
        },
        enumerable: false,
        configurable: true
    });
    Entity.prototype.reset = function () {
        this.components.clear();
        // disabled to diagnose issues...
        this._id = 0;
        this._destroyed = true;
    };
    Entity.prototype.clone = function (other) {
        var _this = this;
        other.components.forEach(function (value, key) {
            _this.components.set(key, value);
        });
        this._id = other.id;
    };
    return Entity;
}());
export { Entity };
//# sourceMappingURL=Entity.js.map